import React from 'react';
import { useAuth } from '../context/AuthContext';
import '../index.css';
import googleLogo from '../../src/google.png';
import facebookLogo from '../../src/Facebook.png';
import githubLogo from '../../src/Github.png';

const SocialRegisterButtons = () => {
  const { loginWithFacebook, loginWithGithub } = useAuth();

  const handleSocialAuth = (provider) => {
    if (provider === 'facebook') {
      loginWithFacebook().catch(error => {
        console.error('Facebook login failed:', error);
        alert('Facebook login failed: ' + error.message);
      });
    } else if (provider === 'github') {
      loginWithGithub().catch(error => {
        console.error('GitHub login failed:', error);
        alert('GitHub login failed: ' + error.message);
      });
    } else {
      window.location.href = `/auth/${provider}`;
    }
  };

  return (
    <div className="social-register-container">
      <p className="or-separator">ou inscrivez-vous avec</p>

      <button className="social-btn google" onClick={() => handleSocialAuth('google')}>
        <img src={googleLogo} alt="Google" className="social-icon" />
        Google
      </button>

      <button className="social-btn facebook" onClick={() => handleSocialAuth('facebook')}>
        <img src={facebookLogo} alt="Facebook" className="social-icon" />
        Facebook
      </button>

      <button className="social-btn github" onClick={() => handleSocialAuth('github')}>
        <img src={githubLogo} alt="GitHub" className="social-icon" />
        GitHub
      </button>
    </div>
  );
};

export default SocialRegisterButtons;
